module.exports = __webpack_public_path__ + "img/icon3.ad1aa139.svg";